import { WorkplaceChargeLeadTimeDifferentialListResponseSchema } from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";
import { useGetParsedQuery } from "@src/appV2/api/useGetParsedQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";

interface UseGetWorkplaceChargeLeadTimeDifferentialsParams {
  workplaceId: string;
}

interface UseGetWorkplaceChargeLeadTimeDifferentialsOptions {
  enabled?: boolean;
}

export function useGetWorkplaceChargeLeadTimeDifferentials(
  params: UseGetWorkplaceChargeLeadTimeDifferentialsParams,
  options: UseGetWorkplaceChargeLeadTimeDifferentialsOptions = {}
) {
  const { workplaceId } = params;
  const { enabled = true } = options;

  const url = `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/charge-lead-time-differentials`;

  return useGetParsedQuery({
    url,
    responseSchema: WorkplaceChargeLeadTimeDifferentialListResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKPLACE_CHARGE_LEAD_TIME_DIFFERENTIALS_FAILURE,
    },
    enabled: enabled && isDefined(workplaceId),
  });
}
